export default __webpack_public_path__ + "static/media/TableSortArrow.2f39cb98.svg";